import axios from "axios";
import type { NamedColor } from "components/filter/color-filter/ColorFilter";
import i18next from "i18next";
import { type ColorCieLab, labToCss } from "./color-math";

export interface RalClassicColor {
  ral: string;
  lab: ColorCieLab;
  name: string;
  group: string;
  cssColor: string;
  code: string;
}

const ralColorGroups = new Map();
ralColorGroups.set("RAL 1", "Yellow");
ralColorGroups.set("RAL 2", "Orange");
ralColorGroups.set("RAL 3", "Red");
ralColorGroups.set("RAL 4", "Violet");
ralColorGroups.set("RAL 5", "Blue");
ralColorGroups.set("RAL 6", "Green");
ralColorGroups.set("RAL 7", "Grey");
ralColorGroups.set("RAL 8", "Brown");
ralColorGroups.set("RAL 9", "White and black");

export interface ResRalClassicColor {
  lab: ColorCieLab;
  name: string;
  code: string;
}

export function loadRalClassicColors(): Promise<Array<RalClassicColor>> {
  const currentLanguage = i18next.language;
  let jsonFileName = "ral-classic.json";

  if (currentLanguage === "de") {
    jsonFileName = "ral-classic-de.json";
  } else if (currentLanguage === "zh") {
    jsonFileName = "ral-classic-zh.json";
  }

  return axios
    .get(`/colors/${jsonFileName}`)
    .then((res) => res.data)
    .then((raw) =>
      raw.map((color: ResRalClassicColor) =>
        convertNamedColorToRalClassicColor({
          name: color.name,
          value: color.lab,
          code: color.code,
        }),
      ),
    );
}

export function convertNamedColorToRalClassicColor(
  namedColor: NamedColor,
): RalClassicColor {
  const regexRal = /(RAL \d+)\s(.+)/;
  const ral: string = namedColor.name.match(regexRal)?.[1] ?? "";

  return {
    ral,
    lab: namedColor.value,
    name: namedColor.name,
    code: namedColor.code || "",
    group: ralColorGroups.get(ral?.substring(0, "RAL 0".length)),
    cssColor: labToCss(namedColor.value),
  };
}
